import parameters from '@atlassian/jira-relay/src/__generated__/DeleteProjectModalQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = { projectId: string };

export const deleteProjectModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-delete-project-modal" */ './src/ui/DeleteProjectModal.tsx'
			),
	),
	getPreloadProps: ({ projectId }: EntryPointParams) => ({
		queries: {
			project: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					projectId,
				},
			},
		},
	}),
});
